export class AccountDetailsVM {
  AccountNumber: number;
  AccountName: string;
  AccountType: string;
  Address1: string;
  Address2: string;
  EmailAddress: string;
  City: string;
  State: string;
  ZipCode: string;
}

export class tableHeader {
  headertxt: string;
  columnfield: string;
  className: string;
}

export class eventDetail {
  event: string;
  eventData: any;
  rowData: any;
}
